import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { UserSchema } from '../../realm/contactSchema';
import { MessageSchema } from '../../realm/schema';
import { getDisplayName, getMsgContent, isGroupTopic } from '../../utils/utils';
import { color_333333, color_main, ColorLine } from '../../assets/style/colors';
import { ImageView } from '../../components/ImageView';
import { Str_Reply } from '../../language/string_res';
import { getUserName } from './chat-helper';
import { MessageType } from '../../constants/types';
import { Meta } from '../../../imsdk/db/t_msg';
import { chatViewStyles } from './ChatViewItemRender';
import { QuoteContentRender } from './components/QuoteRender';

type MessageUser = MessageSchema & { user: UserSchema };
type QuoteTextProps = {
	msg?: MessageUser;
	currentUid: number;
	onClose?(): void;
};

export const QuoteText = (props: QuoteTextProps) => {
	const [quoteMeta, setQuoteMeta] = useState<Meta | undefined>(undefined);
	const isGroup = isGroupTopic(props.msg?.tid ?? '0');

	useEffect(() => {
		const msg = props.msg;
		// 组装发给对方的消息中的引用信息
		if (msg) {
			const isQuoteSelf = msg.sender === props.currentUid ? '1' : '0';
			const duration = msg.type == MessageType.VOICE ? msg.meta?.duration || '1' : '';
			let thumbnail = '';
			if (msg.type == MessageType.VIDEO || msg.type == MessageType.IMAGE) {
				if (msg.thumbnailPath && msg.thumbnailPath?.startsWith('http')) {
					thumbnail = msg.thumbnailPath;
				}
			}

			// 组装发给对方的消息中的引用信息
			const meta: Meta = {
				quoteMid: msg.mid,
				quoteTid: msg.tid,
				quoteUid: `${msg.sender}`,
				quoteUser: !isGroup ? getUserName(msg.user) : (msg.user?.nick || msg.user?.name || msg.user.employee),
				quoteCnt: msg.content || '',
				quoteType: msg.type,
				duration: duration,
				isQuoteSelf: isQuoteSelf, // 是否引用自己的消息
				thumbnail: thumbnail,
			};

			// 可能存在本地图片
			if (msg.type == MessageType.IMAGE || msg.type == MessageType.VIDEO || msg.type == MessageType.DOCUMENT) {
				if (msg.upload_path?.length != 0) {
					if ((msg.upload_path?.length ?? 0) > 0) {
						meta.upload_path = msg.upload_path;
					}
				}

				if ((msg.thumbnailPath?.length ?? 0) > 0) {
					meta.thumbnail = msg.thumbnailPath;
				}
			}

			setQuoteMeta(meta);
		} else {
			setQuoteMeta(undefined);
		}
	}, [props.msg]);

	return (
		<>
			{quoteMeta ? (
				<View style={styles.viewBox}>
					<View style={styles.line} />
					<Text style={styles.viewText} numberOfLines={1}>
						{Str_Reply}
					</Text>

					<QuoteContentRender maxLine={1} meta={quoteMeta} disabled={true} style={{ paddingHorizontal: 5 }} />
					<View style={{ flex: 1 }} />
					<ImageView
						onClick={() => props.onClose?.()}
						style={{ marginEnd: 8, padding: 5 }}
						imgStyle={{ width: 20, height: 20 }}
						source={require('../../assets/image/icon_del.png')}
					/>
				</View>
			) : null}
		</>
	);
};

const styles = StyleSheet.create({
	viewBox: {
		borderTopWidth: 1,
		borderTopColor: ColorLine,
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		height: 40,
	},
	line: {
		width: 2,
		height: 20,
		backgroundColor: color_main,
		marginLeft: 12,
		marginRight: 4,
	},
	viewText: {
		fontSize: 14,
		color: color_333333,
	},
});
